// Generated by ReScript, PLEASE EDIT WITH CARE


function calculateAccuracy(responsesCorrect, responsesComplete) {
  return responsesCorrect / responsesComplete;
}

export {
  calculateAccuracy ,
}
/* No side effect */
